import SimpleComponentRegistery from "./SimpleComponentRegistery";

/**
 * Base class which should be extended when creating components for SimpleComponentRegistery
 * @export
 * @class Component
 */
export default class Component
{
    constructor(element)
    {
        this.element = element;
    }

    /**
     * Helper method to send messages to other components
     * @param  {string} type_name 
     * @param  {string} message_name 
     * @param  {object|undefined} message_data 
     * @return {void}
     * @memberof Component
     */
    sendMessage(type_name, message_name, message_data)
    {
        SimpleComponentRegistery.sendMessage(type_name, message_name, message_data);
    }

    /**
     * Handler for incomming messages
     * @param  {string} name 
     * @param  {object|undefined} data 
     * @return {void}
     * @memberof Component
     */
    onMessage(name, data)
    {
    }
}